import { Component, Input, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-unsaved-changes-modal',
  templateUrl: './unsaved-changes-modal.component.html',
  imports: [NgIf, NgTemplateOutlet, TranslatePipe],
})
export class UnsavedChangesModalComponent {
  @Input() titleKey = 'UnsavedChanges.Title';
  @Input() messageKey = 'UnsavedChanges.Message';
  @Input() cancelKey = 'UnsavedChanges.Stay';
  @Input() confirmKey = 'QuitAndDiscard';
  @Input() messageTemplate?: TemplateRef<any>;
  constructor(public modal: NgbActiveModal) {}
}
